<script>
  /* Executable code section of the program */
  //Tools importation
  import { invitedAttendeesArray, customBreakId } from "../../apis/storage";
  import { deleteCustomElements } from "../../apis/APIS";
  //Auxiliary variables
  export let data;
  export let attendeId;
  export let isCheckedExtern;

  //functions to get events for the checkbox
  const handleCheck = (e) => {
    let isChecked = e.target.checked;
      if (isChecked) {
        inviteAttendee(data);
      } else {
        deleteInvitedAttendee(data);
      }
  };
  //Functions to add attendees
  // Add attendee
  const inviteAttendee = (data) => {
    let attendee = {};
    attendee.name = data.name;
    attendee.surname = data.surname;
    attendee.country = data.country;
    attendee.company = data.company || data.department;
    attendee.jobtittle = data.jobtittle;
    attendee.email = data.email;
    attendee.profileImgUrl = data.profileImgUrl;
    attendee.id = data.id;

    invitedAttendeesArray.update((attendees) => {
      return [...attendees, attendee];
    });
  };

  // Delete attendee
  const deleteInvitedAttendee = (data) => {
    invitedAttendeesArray.update((attendees) => {
      return attendees.filter((attendee) => attendee.id !== data.id);
    });
  };

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="bodyCard" id="container">
  <label class="checkbox-container">
    <input
      type="checkbox"
      id={attendeId}
      class="checkBox"
      on:change={handleCheck}
      bind:checked={isCheckedExtern}
      key={attendeId}
    />
    <div class="cardContainer">
      <div class="avatarContainer">
        {#if data.profileImgUrl === ""}
          <div class="circle">
            {data.name.slice(0, 1)}
            {data.surname.slice(0, 1)}
          </div>
        {:else}
          <img src={data.profileImgUrl} alt="AvatarProfile" />
        {/if}
      </div>
      <div class="infoContainer">
        <p>
          {data.name}
          {data.surname} <br />
          {data.jobtittle} <br />
          {data.company} <br />
          {data.country}
        </p>
      </div>
    </div>
  </label>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .bodyCard {
    width: 30%;
    height: auto;
    margin: 10px;
  }
  .checkbox-container {
    width: 100%;
    height: 100px;
    background-color: white;
    display: flex;
    padding: 15px;
  }
  .checkbox-container:hover {
    cursor: pointer;
  }
  .cardContainer {
    width: 100%;
    height: auto;
    display: flex;
  }
  .avatarContainer {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 5px;
  }
  .circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #ed2824;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .infoContainer {
    width: 70%;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
  p {
    font-size: 12px;
    padding: 0 5px;
    text-align: left;
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .bodyCard {
      background-color: #f4f4f4;
      width: 60%;
      height: auto;
      margin: 5px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .bodyCard {
      background-color: #f4f4f4;
      width: 100%;
      height: auto;
      margin: 5px;
    }
  }

  /* End of the section */
</style>
